export class StartQueryExecutionRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "query",
            "baseName": "query",
            "type": "string",
            "format": ""
        },
        {
            "name": "engine",
            "baseName": "engine",
            "type": "QueryEngine",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return StartQueryExecutionRequest.attributeTypeMap;
    }
    constructor() {
    }
}
